<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.speed") }}</label>
          <el-slider
            v-model="speed"
            :step="1"
            :min="1"
            :max="speeds.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.charlevel") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="7"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.screenwidth") }}</label>
          <el-slider
            v-model="width"
            :step="1"
            :min="1"
            :max="3"
            show-stops
            :marks="{
              1: $t('module.short'),
              2: $t('module.mid'),
              3: $t('module.long'),
            }"
          ></el-slider>
        </div>
        <div class="col-md-12">
          <label for="">{{ $t("module.screenheight") }}</label>
          <el-slider
            v-model="height"
            :step="1"
            :min="1"
            :max="3"
            show-stops
            :marks="{ 1: $t('module.short'), 2: $t('module.mid'), 3: 'UZUN' }"
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div
      @click="
        pause = true;
        $root.$emit('pause', true);
      "
      id="goz_esnetme"
      :style="{ width: getWidth + 'px', height: getHeight + 'px' }"
    >
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <div
        v-if="currentCounter != 0"
        class="dark-inverted"
        style="
          font-size: 20px;
          border-radius: 5px;
          cursor: pointer;
          display: inline-block;
          text-align: center;
          margin: 3px;
          position: absolute;
        "
        :style="{
          marginRight: 5 + 'px',
          top: this.pos.top + 'px',
          left: this.pos.left + 'px',
        }"
      >
        {{ currentLetter }}
      </div>
    </div>
    <div
      :style="{ width: 700 + 'px' }"
      style="margin: 0 auto; border-radius: 0px; margin-top: 15px"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
        "
        v-if="pause == false"
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            flex: 1;
            margin-right: 20px;
            position: relative;
          "
        >
          <el-input
            v-if="currentCounter == 0"
            @keyup.enter.native="check"
            style="width: 100%; margin-right: 10px; font-size: 22px"
            v-model="answer"
            ref="inpt"
            :class="backgroundColor"
            :placeholder="$t('module.cevrefokus.description')"
          ></el-input>
          <el-button v-if="currentCounter == 0" type="primary" @click="check"
            >></el-button
          >
          <el-button
            v-if="currentCounter == 0"
            style="
              position: absolute;
              right: 60px;
              bottom: -30px;
              margin-left: 0px;
              background: transparent;
              border: none;
              color: #333;
            "
            type="warning"
            @click="start"
            size="mini"
            >{{ $t("goremedim") }}</el-button
          >
        </div>
        <div style="display: flex; flex-direction: row">
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              "
            >
              <i class="fas fa-times"></i>
            </div>
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              "
              >{{ totalFalse }}</span
            >
          </span>
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              "
              >{{ totalTrue }}</span
            >
          </span>
          <svg
            height="40px"
            viewBox="0 0 512 512"
            width="40px"
            xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2"
          >
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)"
            />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import level1 from "./level1";
import level2 from "./level2";
import level3 from "./level3";
import level4 from "./level4";
import level5 from "./level5";
import level6 from "./level6";
import level7 from "./level7";
import words_ru from "./words_ru";
import words_az from "./words_az";
export default {
  props: ["config"],
  name: "GozEsnekligi",
  data() {
    return {
      pause: false,
      speed: 1,
      speeds: [
        2000, 1900, 1800, 1700, 1600, 1500, 1400, 1300, 1200, 1100, 1000, 800,
        600, 500, 400, 300,
      ],
      top: 0,
      left: 0,
      word: null,
      rotate: 0,
      currentCounter: 5,
      startCounter: 5,
      level: 1,
      levels: [
        [...level1.split(",").filter((k) => k != "")],
        [...level2.split(",").filter((k) => k != "")],
        [...level3.split(",").filter((k) => k != "")],
        [...level4.split(",").filter((k) => k != "")],
        [...level5.split(",").filter((k) => k != "")],
        [...level6.split(",").filter((k) => k != "")],
        [...level7.split(",").filter((k) => k != "")],
      ],
      options: [],
      currentLetter: "",
      lodash: _,
      wrapper: {
        width: 0,
        height: 0,
      },
      positions: [],
      totalTrue: 0,
      totalFalse: 0,
      counts: [],
      flash: false,
      answer: null,
      pos: {
        top: 0,
        left: 0,
      },
      settings: false,
      width: 1,
      height: 1,
      autoLevel: false,
      levelLock: false,
      answerStack: [],
      reactions: [],
      lastPickTime: new Date().getTime(),
      backgroundColor: null,
      lock: false,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    pick(index) {
      this.options[index].picked = true;
    },
    getColor(letter) {
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == false
      ) {
        return "#ddd";
      }
      if (
        this.flash == true &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter == this.currentLetter &&
        letter.picked == true
      ) {
        return "green";
      }
      if (
        this.flash == false &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
      if (
        this.flash == true &&
        letter.letter != this.currentLetter &&
        letter.picked == true
      ) {
        return "red";
      }
    },
    check() {
      if (this.lock || this.answer == "" || this.answer == null) return;
      this.lock = true;
      clearInterval(this.interval);
      if (this.$slugify(this.answer) == this.$slugify(this.currentLetter)) {
        this.totalTrue += 1;
        this.answerStack.push(true);
        this.reactions.push(new Date().getTime() - this.lastPickTime);
        this.backgroundColor = "green";
      } else {
        this.totalFalse += 1;
        this.answerStack.push(false);
        this.backgroundColor = "red";
        this.answer = this.currentLetter;
      }
      if (this.answerStack.length == 6) {
        this.answerStack.splice(0, 1);
      }

      setTimeout(() => {
        this.backgroundColor = null;
        this.answer = null;
        this.lock = false;
        this.start();
      }, 1500);
    },
    start() {
      this.flash = false;
      this.positions = [];
      this.options = [];
      this.currentCounter = 3;

      var before = this.currentLetter.trim();

      while (true) {
        this.currentLetter =
          this.levels[this.level - 1][
            _.random(0, this.levels[this.level - 1].length - 1)
          ];
        if (this.currentLetter != before) {
          break;
        }
      }

      this.pos = {
        top: _.random(20, this.wrapper.height - 50),
        left: _.random(20, this.wrapper.width - this.currentLetter.length * 10),
      };

      this.interval = setTimeout(() => {
        this.lastPickTime = new Date().getTime();
        this.currentCounter = 0;
      }, this.speeds[this.speed - 1]);
    },
  },
  computed: {
    currentSpeed() {
      return this.speeds[this.speed - 1];
    },
    getWidth() {
      var w = [350, 500, 700];
      return w[this.width - 1];
    },
    getHeight() {
      var w = [200, 350, 500];
      return w[this.height - 1];
    },
  },
  created() {
    if (this.$i18n.locale == "ru") {
      this.levels = [
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 6),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 7),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 8),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 9),
        ],
        [
          ...words_ru
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length > 10),
        ],
      ];
    }

    if (this.$i18n.locale == "az") {
      this.levels = [
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length <= 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length ==5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 4),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length == 5),
        ],
        [
          ...words_az
            .split(",")
            .map((k) => k.trim())
            .filter((k) => k != "")
            .filter((k) => k.length > 4),
        ],
      ];
    }

    if (this.config != null && this.config != undefined) {
      if (this.config.level != null && this.config.level != "")
        this.level = this.config.level;
      if (this.config.speed != null && this.config.speed != "")
        this.speed = this.config.speed;
      this.autoLevel = this.config.auto_level;
    }
  },
  watch: {
    currentCounter: function () {
      if (this.currentCounter == 0) {
        setTimeout(() => {
          this.$refs.inpt.focus();
        }, 100);
      }
    },
    currentSpeed: function () {
      if (this.levelLock) {
        return;
      }
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    level: function () {
      if (this.level < 3) {
        this.width = 1;
        this.height = 1;
      }
      if (this.level >= 3 && this.level <= 5) {
        this.width = 2;
        this.height = 2;
      }
      if (this.level >= 6 && this.level <= 7) {
        this.width = 3;
        this.height = 3;
      }

      if (this.levelLock) {
        return;
      }

      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.start();
    },
    getWidth: function () {
      if (this.levelLock) {
        this.wrapper = {
          width: this.getWidth,
          height: this.getHeight,
        };
        return;
      }
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.$nextTick(() => {
        this.wrapper = {
          width: this.getWidth,
          height: this.getHeight,
        };
        setTimeout(() => {
          this.start();
        });
      });
    },
    getHeight: function () {
      if (this.levelLock) {
        this.wrapper = {
          width: this.getWidth,
          height: this.getHeight,
        };
        return;
      }
      clearInterval(this.interval);
      clearInterval(this.startInterval);
      this.$nextTick(() => {
        this.wrapper = {
          width: this.getWidth,
          height: this.getHeight,
        };
        setTimeout(() => {
          this.start();
        });
      });
    },
    answerStack: {
      deep: true,
      handler: function () {
        if (this.answerStack.filter((k) => k == true).length == 3) {
          this.answerStack = this.answerStack.filter((k) => k == false);
          if (this.autoLevel == 0) return;

          this.levelLock = true;
          this.level = Math.min(
            this.level + 1,
            this.config && this.config.max_level ? this.config.max_level : 7
          );
          this.speed = Math.min(
            this.speed + 1,
            this.config && this.config.max_speed ? this.config.max_speed : 16
          );
          setTimeout(() => {
            this.levelLock = false;
          }, 500);
        }

        if (this.answerStack.filter((k) => k == false).length == 3) {
          this.answerStack = this.answerStack.filter((k) => k == true);
          if (this.autoLevel == 0) return;

          this.levelLock = true;
          this.level = Math.max(this.level - 1, 1);
          this.speed = Math.max(this.speed - 1, 1);
          setTimeout(() => {
            this.levelLock = false;
          }, 500);
        }
      },
    },
  },
};
</script>

<style lang="less">
#goz_esnetme {
  width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.red .el-input__inner {
  background-color: red !important;
  color: white;
}

.green .el-input__inner {
  background-color: #1c449c !important;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/CevreFokus.vue